import {
  Box,
  Center,
  Flex,
  Text
} from "@chakra-ui/react";
import Lang from "../../Lang";
import { useState } from "react";


export default function CardPhilosophy({ id, image, title, texts }) {
  const [overCard, setOverCard] = useState(0);

  return (
    <Center>
      <Flex
        onMouseOver={() => setOverCard(id)}
        onMouseLeave={() => setOverCard(0)}
        overflow={'hidden'}
        direction={'column'}
        px={{ base: 2 }}
      >
        <Box
          display={{ base: "none", md: "flex" }}
        >
          <Desktop
            id={id}
            image={image}
            title={title}
            texts={texts}
            overCard={overCard}
          />
        </Box>

        <Box
          display={{ base: "flex", md: "none" }}
        >
          <Mobil
            image={image}
            title={title}
            texts={texts}
          />
        </Box>

      </Flex>
    </Center>
  );
}

function Desktop({ id, image, title, texts, overCard }) {
  return (
    <>
      <Box
        bgImage={image}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        w={{ md: 320, lg: 450 }}
        h={{ md: 500, lg: 550 }}
        display={overCard === id ? "none" : ""}
        borderRadius={40}
      >
        <Text
          align="center"
          pt={{ md: 400, lg: 400, xl: 400 }}
          fontSize="2.5em"
          className="barlow-black"
        >
          <Lang text={title} />
        </Text>
      </Box>

      {/* Content to show when mouse over */}
      <Box
        bgImage={image}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        w={{ md: 320, lg: 450 }}
        h={{ md: 500, lg: 550 }}
        display={overCard === id ? "" : "none"}
        borderRadius={{ base: 30, md: 50, xl: 50 }}
      >
        <Box
          bg={"rgb(0,0,0,0.6)"}
          h={"100%"}
        >
          <Text
            align={"center"}
            pt={{ md: "50px", lg: "50px", xl: "40px" }}
            pb={{ md: 4, lg: 5, xl: 5 }}
            fontSize="2.5em"
            className="barlow-black"
            display={overCard === id ? "" : "none"}
          >
            <Lang text={title} />
          </Text>
          <Text
            display={overCard === id ? "" : "none"}
            fontSize={{ md: "1.5em", lg:"1.7em", xl: "1.8em" }}
            color="white"
            px={"20px"}
            pb={4}
          >
            <Lang text={texts} />
          </Text>
        </Box>

      </Box>
    </>
  );
}

function Mobil({ image, title, texts }) {
  return (
    <>
      <Box
        bgImage={image}
        backgroundSize={'cover'}
        backgroundPosition={'center'}
        w={{ base: "full" }}
        h={{ md: 500, lg: 650 }}
        borderRadius={{ base: 30, md: 50, xl: 50 }}
        className="borderCard"
      >
        <Box
          bg={"rgb(0,0,0,0.6)"}
          h={"100%"}
        >
          <Text
            align={"center"}
            pt={{ base: "50px" }}
            pb={{ base: 3 }}
            fontSize="2.5em"
            className="barlow-black"
          >
            <Lang text={title} />
          </Text>
          <Text
            fontSize={{ base: "1.3em" }}
            color="white"
            px={"20px"}
            pb={{ base: 20 }}
          >
            <Lang text={texts} />
          </Text>
        </Box>

      </Box>
    </>
  );
}